export const trucks = [
  {
    type: "tautliner",
    name: "Tautliner (Curainsider)",
    insideLength: "13.600 m",
    insideWidth: "2.500 m",
    insideHeight: "2.650 m",
    capacity: "90 m3",
    maxWeight: "24500 Kgs",
    disabled: false,
    description: [
      "These are similar to the Euroliners, with sliding roofs, sliding curtains and solid rear doors but do not have side gates or sideboards. The Tautliner has all-round flexibility for loading and unloading from the rear, sides and overhead.",
    ],
  },
  {
    type: "refrigerated",
    name: "Refrigerated Truck",
    insideLength: "13.600 m",
    insideWidth: "2.500 m",
    insideHeight: "2.650 m",
    capacity: "90 m3",
    maxWeight: "24500 Kgs",
    disabled: false,
    description: [
      "Semi-trailers equipped with a refrigeration unit provide automatic temperature controls. Designed for the transportation of goods requiring deep freezing or cooling. Deep-frozen products, such as carcasses on hooks and fish, are transported at temperatures ranging from -24 to -12 degrees Celsius.For the transportation of chilled animal or vegetable products, you can use the -6 to 0 degree mode.",
    ],
  },
  {
    type: "isotherm",
    name: "Isotherm Truck",
    insideLength: "13.360 m",
    insideWidth: "2.600 m",
    insideHeight: "2.650 m",
    capacity: "92 m3",
    maxWeight: "22000 Kgs",
    disabled: false,
    description: [
      "The cargo compartment of the semi-trailer is thermally insulated but not equipped with a refrigeration unit. Designed for short-term transportation of perishable goods, it maintains the desired internal temperature for a limited time.",
    ],
  },
  {
    type: "mega_trailer",
    name: "Mega-trailer",
    insideLength: "13.600 m",
    insideWidth: "2.470 m",
    insideHeight: "3.000 m",
    capacity: "100 m3",
    maxWeight: "32800 Kgs",
    disabled: false,
    description: [
      "Mega curtainsiders feature a massive 100m³ capacity. The larger internal height enables shippers to maximize consignment size whilst having the benefits of a straight frame loading bed. All trailers have easy loading and discharge via open side and rear door access including sliding and lifting roof. They are also equipped with 32 sideboards.",
    ],
  },
  {
    type: "jumbo",
    name: "Jumbo",
    insideLength: "8.000 m",
    insideWidth: "2.480 m",
    insideHeight: "2.950 m",
    capacity: "120 m3",
    maxWeight: "23000 Kgs",
    disabled: false,
    description: [
      "The term jumbo refers to a special large type of truck and the transports carried out with these trucks. The jumbo trucks, unlike regular trucks, offer a much larger load volume. Therefore, the jumbo trucks naturally transport goods that occupy a great deal of volume and are also frequently used in the automotive industry due to the loading height of 3 meters.",
    ],
  },
  {
    type: "custom_truck",
    name: "Custom truck",
    insideLength: "13.600 m",
    insideWidth: "2.500 m",
    insideHeight: "2.650 m",
    capacity: "90 m3",
    maxWeight: "24500 Kgs",
    disabled: false,
    description: [""],
  },
  // {
  //   type: 'FTL_150',
  //   name: "150' FTL",
  //   insideLength: '14.400 m',
  //   insideWidth: '2.500 m',
  //   insideHeight: '2.800 m',
  //   capacity: '130 m3',
  //   maxWeight: '15000 Kgs',
  //   disabled: false,
  //   description: [''],
  // },
];
